<div class="card">
<div *ngIf="displaySpeedDial" class="speedDial speeddial-tooltip-demo">
    <p-speedDial [model]="items" showIcon="pi pi-bars" hideIcon="pi pi-times" buttonClassName="p-button-outlined"
    direction={{dialDirection}} [transitionDelay]="100"  type={{dialType}}
    ></p-speedDial>
</div>
</div>
